function warn(operation) {
    console.warn(`You are using the ceramic.pin.${operation} API which has been removed and is now a no-op.  This operation will not have any affect.  If you want to change the pin state of streams please use the new ceramic.admin.pin API which requires a DID that has been granted admin access on the Ceramic node.`);
}
export class DummyPinApi {
    async add() {
        warn(`add`);
        return;
    }
    async ls() {
        warn(`ls`);
        return;
    }
    async rm(streamId, opts) {
        warn(`ls`);
        return;
    }
}
//# sourceMappingURL=dummy-pin-api.js.map